import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Alert} from "@mui/material";
import AiProfileCard from "@/components/AiProfileCard";
import {getDsContext} from "@/utils/dsContext";
import {useScoutingProfile, saveProfile} from "@/utils/scoutingProfileData";
export default function SharedPlayerProfile(props) {
	useSelector((s) => s.user);
	useSelector((s) => s.token);
	useSelector((s) => s.season?.id);
	return <Profile key={props.playerId + ":" + getDsContext()} {...props} />;
}
function Profile({playerId, player, inputs}) {
	const source = useScoutingProfile(playerId);
	const refresh = source.refresh;
	const [error, setError] = useState(""),
		[conflict, setConflict] = useState(false),
		[revision, setRevision] = useState(0);
	useEffect(() => {
		refresh().catch(() => {});
	}, [player, refresh]);
	const save = async (text, fields) => {
		try {
			await saveProfile(playerId, {text, ...fields});
			setError("");
		} catch (e) {
			setError(
				e.response?.data?.error || e.message || "Salvataggio non riuscito.",
			);
			if (e.response?.status === 409) setConflict(true);
			throw e;
		}
	};
	const reload = async () => {
		try {
			await source.refresh(true);
			setConflict(false);
			setError("");
			setRevision((x) => x + 1);
		} catch (e) {
			setError(e.message || "Caricamento non riuscito.");
		}
	};
	return (
		<div>
			{(source.status === "idle" || source.status === "loading") && (
				<p>Caricamento profilo condiviso…</p>
			)}
			{source.status === "error" && (
				<Alert severity="error">
					Profilo non disponibile.{" "}
					<button onClick={() => source.refresh(true).catch(() => {})}>
						Riprova caricamento profilo
					</button>
				</Alert>
			)}
			{error && <Alert severity="error">{error}</Alert>}
			{conflict && (
				<button onClick={reload}>Ricarica dal server (scarta la bozza)</button>
			)}
			<AiProfileCard
				key={revision}
				profile={source.status === "ready" ? source.data?.profile : null}
				inputs={inputs}
				outdated={source.data?.outdated ?? false}
				currentSignature={source.data?.currentSignature}
				onSave={source.canWrite && !conflict ? save : undefined}
				busy={source.busy || source.status !== "ready" || conflict}
				available={source.status === "ready"}
			/>
		</div>
	);
}
